import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import CaseForm from "../components/CaseForm";
import { toast } from "sonner";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Heart } from "lucide-react";

export default function NewCasePage({ kind }) {
  const navigate = useNavigate();
  const { t } = useI18n();
  const { user } = useAuth();
  const [submitted, setSubmitted] = useState(false);
  const isAnte = kind === "ante_mortem";
  const isFamily = user?.role === "family";
  const workspace =
    user?.role === "family" ? t("dash.workspace.family")
    : user?.role === "admin" ? t("dash.workspace.admin")
    : t("dash.workspace.authority");

  if (submitted) {
    return (
      <div className="mx-auto max-w-2xl px-6 py-16" data-testid="family-thankyou-page">
        <div className="rounded-xl border border-[#4A7C59]/25 bg-gradient-to-b from-[#F2F6F3] to-white p-8 text-center shadow-sm sm:p-12">
          <span className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-[#4A7C59]/10 text-[#4A7C59]">
            <Heart size={26} />
          </span>
          <h1 className="mt-5 font-heading text-2xl font-semibold text-[#1A2024] sm:text-3xl" data-testid="thankyou-title">
            {t("thanks.title")}
          </h1>
          <div className="mx-auto mt-5 max-w-lg space-y-3 text-left font-body text-sm leading-relaxed text-[#2E3A46]">
            <p>{t("thanks.body1")}</p>
            <p>{t("thanks.body2")}</p>
            <p>{t("thanks.body3")}</p>
            <p className="text-[#5C6873]">{t("thanks.body4")}</p>
          </div>
          <Link to="/dashboard">
            <Button className="mt-8 bg-[#2E3A46] text-white hover:bg-[#1A2024]" data-testid="thankyou-back-btn">
              {t("thanks.back")}
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-3xl px-6 py-10" data-testid="new-case-page">
      <p className="font-body text-xs uppercase tracking-[0.18em] text-[#6B7F82]">
        {workspace}
      </p>
      <h1 className="mt-1 font-heading text-3xl font-semibold text-[#1A2024]">
        {isAnte ? t("new.ante.title") : t("new.post.title")}
      </h1>
      <p className="mt-2 max-w-2xl font-body text-sm text-[#5C6873]">
        {isAnte ? t("new.ante.sub") : t("new.post.sub")}
      </p>

      <div className="mt-8">
        <CaseForm
          kind={kind}
          onSubmit={() => {
            if (isAnte && isFamily) {
              setSubmitted(true);
              window.scrollTo({ top: 0 });
            } else {
              toast.success(isAnte ? t("new.ante.title") : t("new.post.title"));
              navigate("/dashboard");
            }
          }}
        />
      </div>
    </div>
  );
}
